// extracted by mini-css-extract-plugin
export default {"container":"container__aIMOF","main":"main__spd1V","icon":"icon__HSPwY"};